import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=2c52a4f8&scoped=true"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52a4f8",
  null
  
)

export default component.exports